import { createLogger } from 'shared/services/logger';
import us from 'uScope/js/defines';
import { vp_mousedclick, vp_mousedown, vp_mousemove, vp_mouseup } from 'uScope/js/hmi/pointerApi';
import { getClassList } from 'uScope/js/lib/utility/helpers';
import app from '../../public-api';

const logger = createLogger('UScope:hmi:Mouse');

app.plugins.register({
  name: 'us:hmi:mouse',
  extends: 'viewport',
  constructor (uScope, viewport) {
    viewport.events.on('viewport:bind-events', (namespace) => {
      const $divViewport = viewport.vpDivGet();
      const mouseHandler = VP_MOUSEHANDLER.bind(null, uScope, viewport);

      $divViewport.on('mousedown' + namespace, function (e) {
        viewport.setImageSelected();
        // necessary for IE panning to halt properly when pan cursor moves off viewport
        e.preventDefault();
        return true;
      });
      $divViewport.on('mousedown' + namespace, function (e) {
        const navMode = viewport.navModeGet();
        // mouse down when autopanning or rastering means stop
        if (navMode === us.eNavModes.nmAutoPan || navMode === us.eNavModes.nmRasterScan) {
          viewport.navModeHalt();
        }
      });

      $divViewport.on('mousedown' + namespace +
        ' mouseup' + namespace +
        ' mouseleave' + namespace +
        ' dblclick' + namespace, mouseHandler);

      $divViewport.on('mousemove' + namespace, mouseHandler);

      $divViewport.on('mousewheel' + namespace, function (e, delta, deltaX, deltaY) {
        // don't try to zoom > scan
        if (viewport.getViewZoom() === 1 && deltaY < 0) {
          return false;
        }

        VP_MOUSEWHEEL(viewport, e, delta, deltaX, deltaY); // perform mouse wheel zoom

        e.preventDefault();
        return false;
      });
    });
  }
});

// VP_MOUSEWHEEL - This function dispatches the viewport mouse wheel events.
function VP_MOUSEWHEEL (viewport, e) {
  viewport.setImageSelected();
  let delta = e.delta || e.originalEvent.wheelDelta;
  if (delta === undefined) {
    delta = e.originalEvent.detail;
  }
  delta = Math.max(-1, Math.min(1, delta)); // cap the delta to [-1,1] for cross browser consistency

  if (delta) {
    // If we're zooming then tell the zoom handler where the mouse is
    const mousePosInViewCoord = us.coordPageToView(e, viewport);
    const WTF_FACTOR = 6.5; // Not sure what this represents but using it causes the zoom to more closely track the pointer position
    const mousePosInBaseCoord = us.coordBaseImage2(mousePosInViewCoord, viewport).subtractPoint(viewport.getViewCenter()).divide(WTF_FACTOR);

    if (delta > 0) {
      mousePosInBaseCoord.multiply(-1);
    }

    viewport.zoomStep(delta * us.zoomSpecs.stepFactor, mousePosInBaseCoord);
  }
}

//    VP_MOUSEHANDLER - This function dispatches viewport mouse click and move events.
function VP_MOUSEHANDLER (uScope, viewport, e) {
  e.preventDefault(); // necessary for IE panning to halt properly when pan cursor moves off viewport

  // The mousemove event is constantly captured yet it is only relevant when in conferencing or in a navmode. So get out as soon as possible
  if (e.type === 'mousemove' && viewport.navModeGet() === us.eNavModes.nmNone &&
    uScope.isRegionCopyActive() === false && uScope.isModeConference() === false) {
    return;
  }

  const sClassList = getClassList(e.currentTarget); // provides sTargetClass === us.clsVIEWPORT
  if (!sClassList) {
    return;
  }
  const sTargetClass = sClassList[0];

  switch (e.type) {
    case ('mousedown'):
      if (sTargetClass === us.clsVIEWPORT || sTargetClass === us.clsAPANIMG) {
        vp_mousedown(uScope, viewport, e);
      }
      break;
    case ('mousemove'):
      if (sTargetClass === us.clsVIEWPORT || sTargetClass === us.clsAPANIMG) { // ok if mouse cursor touches autopan image
        vp_mousemove(uScope, viewport, e);
      } else {
        vp_mouseup(uScope, viewport, e); // if targetClass is something unknown, just stop nav mode via mouseup
      }
      break;
    case ('focus'):
    case ('blur'):
    case ('mouseup'):
    case ('mouseleave'):
      if (sTargetClass === us.clsVIEWPORT) {
        vp_mouseup(uScope, viewport, e);
      }
      break;
    case ('dblclick'):
      if (sTargetClass === us.clsVIEWPORT) {
        vp_mousedclick(uScope, viewport, e);
      }
      break;
    default:
      logger.warn('unimplemented VP_MOUSEHANDLER event: ' + e.type);
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/hmi/mouse/mouse-loader.js